/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../styles/variables';
import AccessibleSVG, { SVGProps } from '../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const LegalFolder56 = (props: SVGProps) => (
    <AccessibleSVG width={56} height={56} viewBox="0 0 56 56" {...props}>
        <g fill="none" fillRule="evenodd">
            <path
                fill={vars.bdlBoxBlue10}
                d="M17 44c2.21 0 4 1.79 4 4s-1.79 4-4 4-4-1.79-4-4 1.79-4 4-4zM45 5a6 6 0 110 12 6 6 0 010-12z"
            />
            <path fill={vars.white} d="M18 16h27a6 6 0 016 6v15a6 6 0 01-6 6H12V22a6 6 0 016-6z" />
            <path
                fill={vars.bdlBoxBlue10}
                fillRule="nonzero"
                d="M14.93 9H8a1 1 0 00-.993.883L7 10v29a1.886 1.886 0 00.034.367c.015.084.036.167.062.247l.045.125.056.128.08.15.063.099.097.131.134.152.168.153.09.07.13.086.111.063.184.085.216.073.159.037.104.016.116.012L9 41a2.001 2.001 0 001.995-1.85L11 39V21c0-2.718 2.35-4.889 5.247-4.996L16.47 16H44v-1a3 3 0 00-2.824-2.995L41 12H19.07a3.003 3.003 0 01-2.38-1.173l-.116-.163-.812-1.219a1.004 1.004 0 00-.708-.437L14.93 9z"
            />
            <path
                fill={vars.bdlBoxBlue}
                fillRule="nonzero"
                d="M14.93 7c.936 0 1.814.437 2.38 1.173l.116.163.812 1.219c.163.243.422.401.708.437l.124.008H41a4.999 4.999 0 014.995 4.783L46 16h-.47c2.923 0 5.346 2.103 5.465 4.792L51 21v17.764c0 1.75-.988 3.348-2.553 4.13a1 1 0 11-.894-1.788 2.618 2.618 0 001.44-2.157l.007-.185V21c0-1.574-1.427-2.905-3.271-2.995l-.2-.005H16.471c-1.874 0-3.365 1.277-3.466 2.832L13 21v18c0 .729-.195 1.413-.536 2.001L22 41a1 1 0 01.117 1.993L22 43H9a4 4 0 01-3.995-3.8L5 39V10a3 3 0 012.824-2.995L8 7h6.93zm0 2H8a1 1 0 00-.993.883L7 10v29a1.886 1.886 0 00.034.367c.015.084.036.167.062.247l.045.125.056.128.08.15.063.099.097.131.134.152.168.153.09.07.13.086.111.063.184.085.216.073.159.037.104.016.116.012L9 41a2.001 2.001 0 001.995-1.85L11 39V21c0-2.718 2.35-4.889 5.247-4.996L16.47 16H44v-1a3 3 0 00-2.824-2.995L41 12H19.07a3.003 3.003 0 01-2.38-1.173l-.116-.163-.812-1.219a1.004 1.004 0 00-.708-.437L14.93 9zM38.5 23a.5.5 0 010 1h-15a.5.5 0 010-1h15zm-25-13a.5.5 0 010 1h-4a.5.5 0 010-1h4z"
            />
            <path
                fill={vars.bdlBoxBlue10}
                fillRule="nonzero"
                d="M36.176 38l6.24 5.154.104.093a1.609 1.609 0 01.009 2.282 1.605 1.605 0 01-2.272 0l-.053-.055L35 39.177 36.176 38zm-.764-7.857l3.445 3.445c.19.19.19.499 0 .69l-7.58 7.58a.488.488 0 01-.689 0l-3.445-3.446a.489.489 0 010-.69l7.58-7.58c.19-.19.499-.19.689 0z"
            />
            <path
                fill={vars.bdlBoxBlue}
                d="M30.5 48a.5.5 0 010 1h-7a.5.5 0 010-1h7zm6.186-19.401l.128.12 3.468 3.467c.916.916.956 2.376.12 3.34l-.12.127-1.833 1.832 5.215 3.999a3.68 3.68 0 11-5.18 5.18l-3.998-5.216-1.833 1.834a2.453 2.453 0 01-3.34.12l-.127-.12-3.468-3.468a2.453 2.453 0 01-.12-3.34l.12-.127 7.629-7.629a2.453 2.453 0 013.34-.12zm.453 10.196l-1.343 1.343 4.408 5.336.053.055a1.605 1.605 0 002.375-.113 1.609 1.609 0 00-.112-2.17l-.104-.092-5.277-4.359zm-9.06-2.009l-.936.937a.486.486 0 00-.063.612l.063.077 3.445 3.445a.487.487 0 00.613.063l.076-.063.937-.936-4.135-4.135zm5-5l-4.293 4.293 4.135 4.135 4.293-4.293-4.135-4.135zm1.72-1.706l-.076.063-.937.936 4.135 4.135.936-.937a.486.486 0 00.063-.612l-.063-.077-3.445-3.445a.487.487 0 00-.613-.063z"
            />
        </g>
    </AccessibleSVG>
);

export default LegalFolder56;
